import { render } from "./Summary.vue?vue&type=template&id=471c704f&scoped=true&ts=true"
import script from "./Summary.vue?vue&type=script&lang=ts"
export * from "./Summary.vue?vue&type=script&lang=ts"

import "./Summary.vue?vue&type=style&index=0&id=471c704f&lang=scss&scoped=true"

import exportComponent from "/opt/build/repo/node_modules/vue-loader-v16/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-471c704f"]])

export default __exports__